import { Amplify } from 'aws-amplify';

// Get the site URL for redirects
const getSiteUrl = () => import.meta.env.PROD ? 'https://pokecardindex.com' : window.location.origin;

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: 'us-east-1_pnDm6uDVn',
      userPoolClientId: process.env.VITE_COGNITO_CLIENT_ID || ''
    }
  }
}); 